import type * as React from 'react';

import type { MarkProps } from '@gitbook/slate-react';

export function MarkBold(props: MarkProps): React.ReactElement {
    const { children, attributes } = props;

    return (
        <strong className="font-bold" {...attributes}>
            {children}
        </strong>
    );
}
